import React, { useState } from 'react'
import { Button} from 'react-bootstrap'
import { Pencil } from 'react-bootstrap-icons'
import InterestsList from '../../user-interests/list'
import userCurrentUser from '../../../hooks/use-current-user'
import { get } from 'lodash'
import EditInterestsForm from '../edit-form'

const InterestsSection = ({
    userId,
    variant,
}) => {
    const { currentUser } = userCurrentUser()
    const editable = userId === get(currentUser, 'id')
    const [ isEditing, setEditing ] = useState()

    const renderInterests = () => {
        if (isEditing) {
            return (
                <div style={{ padding: '20px'}} ><EditInterestsForm userId={userId} onComplete={() => setEditing(false)} /></div>
            )
        }

        return (
            <InterestsList variant={variant} userId={userId} />
        )
    }

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                    flexGrow: '1',
                    fontSize: '1.1em',
                    fontWeight: '700'
                }}>
                    INTERESTS
                </div>
                <div>
                    {editable && !isEditing &&
                        <Button variant='link' title='Edit interests' onClick={() => setEditing(!isEditing)} ><Pencil size={20} /></Button>
                    }
                </div>
            </div>
            <div>
                {renderInterests()}
            </div>
        </div>
    )
}

export default InterestsSection